import axios from 'axios'
import { Message, Loading } from 'element-ui'
import { getToken, removeToken } from '@/utils/auth'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 15000
})

let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (!config.hideLoading) {
      loadingInstance = Loading.service({
        lock: true,
        text: '加载中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      })
    }

    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }

    return config
  },
  error => {
    const config = error.config || {}
    if (!config.hideLoading && loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (!response.config.hideLoading && loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }

    const res = response.data

    // 后端统一响应格式：{ code, msg, data }
    if (res.code !== 0 && res.code !== undefined) {
      if (!response.config.silent || res.code === 401) {
        Message.error(res.msg || '请求失败')
      }

      // Token 失效处理
      if (res.code === 401) {
        removeToken()
        router.push('/login')
      }

      return Promise.reject(new Error(res.msg || 'Error'))
    }

    return res.data
  },
  error => {
    const config = error.config || {}
    if (!config.hideLoading && loadingInstance) {
      loadingInstance.close()
      loadingInstance = null
    }

    const res = error.response && error.response.data
    if (res && res.msg) {
      if (!config.silent || res.code === 401) {
        Message.error(res.msg)
      }
      if (res.code === 401) {
        removeToken()
        router.push('/login')
      }
    } else if (!config.silent) {
      Message.error(error.message || '网络错误')
    }

    return Promise.reject(error)
  }
)

export default service
